import { Slide } from '@/components/core/Slide';
import audioFile from './18-explain.mp3';

const transcript = `
  Ok, laten we de synthografie-opdracht voor Masters doen...

  Mag ik nog iets toelichten voor het publiek voordat we beginnen, Jonathan?
`;

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full">
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
